const MOBILE_NAV_SELECTOR = '.menu-list--mobile';

function closePanels(nav, exceptPanelId = '') {
  nav.querySelectorAll('[data-mobile-nav-panel]').forEach((panel) => {
    if (!(panel instanceof HTMLElement)) return;
    if (panel.dataset.mobileNavPanel === exceptPanelId) return;
    panel.hidden = true;
  });

  nav.querySelectorAll('[data-mobile-nav-toggle]').forEach((toggle) => {
    if (!(toggle instanceof HTMLElement)) return;
    if (toggle.dataset.mobileNavToggle === exceptPanelId) return;
    toggle.setAttribute('aria-expanded', 'false');
  });
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const toggle = event.target.closest('[data-mobile-nav-toggle]');
  if (toggle instanceof HTMLElement) {
    const nav = toggle.closest(MOBILE_NAV_SELECTOR);
    if (!(nav instanceof HTMLElement)) return;

    const panelId = toggle.dataset.mobileNavToggle || '';
    const panel = [...nav.querySelectorAll('[data-mobile-nav-panel]')].find(
      (candidate) => candidate instanceof HTMLElement && candidate.dataset.mobileNavPanel === panelId
    );
    if (!(panel instanceof HTMLElement)) return;

    const shouldOpen = panel.hidden;
    closePanels(nav, shouldOpen ? panelId : '');
    panel.hidden = !shouldOpen;
    toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    event.preventDefault();
    return;
  }

  const closeButton = event.target.closest('[data-mobile-nav-close]');
  if (closeButton instanceof HTMLElement) {
    const nav = closeButton.closest(MOBILE_NAV_SELECTOR);
    if (nav instanceof HTMLElement) closePanels(nav);
    event.preventDefault();
    return;
  }

  document.querySelectorAll(MOBILE_NAV_SELECTOR).forEach((nav) => {
    if (nav instanceof HTMLElement && !nav.contains(event.target)) closePanels(nav);
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll(MOBILE_NAV_SELECTOR).forEach((nav) => {
    if (nav instanceof HTMLElement) closePanels(nav);
  });
});
